import { Component, computed, inject, ViewChild } from '@angular/core';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TableColumn } from '../../../../modules/shared/components/kit/table/table.types';
import { routeParams, translate } from '../../../../modules/shared/shared.global-service';
import { OrganizationSettingsCurrencyStore } from './organization-settings-currency.store';
import { currencyFrag } from './organization-settings-currency.query';
import { CurrencyObject } from '@libs/types/src/mado/object-type/currency/currency.object';
import { TableComponent } from 'packages/client/src/app/modules/shared/components/kit/table/table.component';
import { FilterInput } from '@it2go/data-grid';
import { ConfirmBuilder } from 'packages/client/src/app/modules/shared/service/confirm.builder';
import { OrganizationSettingsCurrencyDialogComponent } from './dialog/organization-settings-currency-dialog.component';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';
import { CheckOrCrossComponent } from '../../../kit/check-or-cross/check-or-cross.component';


@Component({
    selector: 'app-organization-settings-currency',
    templateUrl: './organization-settings-currency.component.html',
    providers: [OrganizationSettingsCurrencyStore],
    imports: [PrimeTemplate, CheckOrCrossComponent, TableComponent],
})
export class OrganizationSettingsCurrencyComponent {
    protected readonly store = inject(OrganizationSettingsCurrencyStore);
    protected readonly dialogService = inject(BaseDialogService);
    protected readonly confirm = inject(ConfirmBuilder);

    protected readonly prefix = 'madoCurrency.';

    protected columns: TableColumn[] = [
        {
            name: 'name',
        },
        {
            name: 'code',
        },
        {
            name: 'isDefault',
        },
    ];


    protected readonly filters = computed<FilterInput[][]>(() => [
        [{ column: 'organizationId', operator: 'EQ', value: [routeParams.organizationId()] }],
    ]);

    @ViewChild('currencyTable') private tableRef!: TableComponent;

    openDialog(currency: CurrencyObject | null = null) {
        const header = `${this.prefix}` + (currency ? 'update' : 'create');
        const dialog = this.dialogService.open(
            OrganizationSettingsCurrencyDialogComponent,
            {
                header: translate.instant(header),
                data: { currency, organizationId: routeParams.organizationId() },
            },
        );

        dialog?.onClose.subscribe((it) => {
            if (it === true) {
                this.tableRef?.reload();
            }
        });
    }

    deleteItem(event: any) {
        this.confirm.confirmDelete(
            async () => {
                await this.store.api.deleteCurrency({ id: event.item.id });
                this.tableRef.reload();
            },
            event,
        );
    }

    protected readonly currencyFrag = currencyFrag;
}
